import type { FormConfig } from '@workspace/core-ts/types';

/**
 * Configuration spécifique pour le formulaire Vélo
 *
 * Cette configuration permet de contrôler l'affichage et le comportement
 * des différents éléments de l'interface du formulaire.
 */
export const veloFormConfig: FormConfig = {
    header: {
        showBackButton: true,
        showLogo: true,
        showPhoneButton: false, // Masqué : bloc "Un conseiller vous aide" / "rappelez-moi" retiré du formulaire Vélo
        showStepper: true,
        phoneNumber: '04 49 02 37 19',
    },
    footer: {
        showBanner: true, // Banner activé pour le formulaire Vélo
        showLinks: true,
    },
    layout: {
        animationType: 'fade',
    },
    features: {
        enableModalRappeler: true,
        enableAutoSave: true,
        enableAnalytics: true,
    },
    analytics: {
        formType: 'velo',
    },
};

// Export par défaut pour faciliter l'import
export default veloFormConfig;
